"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentBlock_1 = __importDefault(require("./TournamentBlock"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var CurrentTournaments = function (_a) {
    var withImage = _a.withImage, Banner = _a.Banner;
    var data = (0, swr_hooks_1.useActiveTournaments)().data;
    var tournamentsToShow = (0, react_1.useMemo)(function () { return data === null || data === void 0 ? void 0 : data.slice(1, data.length); }, [data]);
    if ((tournamentsToShow === null || tournamentsToShow === void 0 ? void 0 : tournamentsToShow.length) === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, tournamentsToShow === null || tournamentsToShow === void 0 ? void 0 : tournamentsToShow.map(function (item, idx) {
            return (react_1.default.createElement(TournamentBlock_1.default, __assign({ key: "tournamentBlock".concat(idx) }, item, { withImage: withImage, Banner: Banner })));
        }))));
};
exports.default = CurrentTournaments;
